var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3d6472",
    width: "20px",
    height: "20px",
    viewBox: "-0.86 0 33.604 33.604",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-481.237 -128.948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.237,162.552a1,1,0,0,1-1-1v-32.6h21.707v17.8H483.237v14.8A1,1,0,0,1,482.237,162.552Zm1-17.8h17.707v-13.8H483.237Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.951,135.709l7.547.051a.631.631,0,0,1,.625.629v10.576a.629.629,0,0,1-.629.629h-7.149a.4.4,0,0,1-.394-.394V135.709m-2-2.014v13.5a2.394,2.394,0,0,0,2.394,2.394h7.149a2.629,2.629,0,0,0,2.629-2.629V136.389a2.629,2.629,0,0,0-2.611-2.629l-9.561-.065Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/country.6f7b8c27b96568e73aae074aa7cc266f.svg";
export { ForwardRef as ReactComponent };